import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'RELATORIO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'RELATORIO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('relatorioForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/relatorio?id_usuario=${getState().auth.usuario.id}`).then(result => {
			dispatch({
				type: 'RELATORIO_LISTADO',
				payload: result
			});
		}).catch(e => {
			console.log(e);
		});
	}
}

export function getListaEstrutura(respostas) {

	return async (dispatch, getState) => {
		let lista = [];
		for (let i = 0; i < respostas.length; i++) {
			const resposta = respostas[i];
			
			let registro = {
				id_checklist_resposta: resposta.id,
				id_checklist: resposta.id_checklist,
				listaArea: [],
				listaPergunta: [],
				listaRespostaItem: []
			};
			await axios.get(`${consts.API_URL}/checklistArea?id_checklist=${registro.id_checklist}`).then(result => {
				registro.listaArea = result.data;
			}).catch(ex => {
				console.log(ex);
			});
			await axios.get(`${consts.API_URL}/checklistItem?id_checklist=${registro.id_checklist}`).then(result => {
				registro.listaPergunta = result.data;
			}).catch(ex => {
				console.log(ex);
			});
			await axios.get(`${consts.API_URL}/checklistRespostaItem?id_checklist_resposta=${registro.id_checklist_resposta}`).then(result => {
				registro.listaRespostaItem = result.data;
			}).catch(ex => {
				console.log(ex);
			});

			lista.push(registro);
		}

		dispatch({
			type: 'RELATORIO_ESTRUTURA_LISTADO',
			payload: lista
		});
	}
}

export function getListaArea(idChecklist) {
	const request = axios.get(`${consts.API_URL}/checklistArea?id_checklist=${idChecklist}`);
	return {
		type: 'RELATORIO_AREA_LISTADO',
		payload: request
	};
}

export function getListaPergunta(idChecklist) {
	const request = axios.get(`${consts.API_URL}/checklistItem?id_checklist=${idChecklist}`);
	return {
		type: 'RELATORIO_PERGUNTA_LISTADO',
		payload: request
	};
}

export function getListaRespostaItem(idChecklistResposta) {
	const request = axios.get(`${consts.API_URL}/checklistRespostaItem?id_checklist_resposta=${idChecklistResposta}`);
	return {
		type: 'RELATORIO_RESPOSTA_ITEM_LISTADO',
		payload: request
	};
}

export function salvar(registro) {
    return async (dispatch, getState) => {

		if (!registro.id) {

	        axios.post(`${consts.API_URL}/relatorio`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(async resp => {
				setSuccess('Operação Realizada com sucesso.');

				let registroCarregado = null;
				
				await axios.get(`${consts.API_URL}/relatorio?id=${resp.data.id}`).then(retorno => {
					registroCarregado = retorno.data[0];
				}).catch(e => {
					console.log(e);
					setErroAPI(e);
				});
				
				dispatch(initForm({
					...registroCarregado
				}));
				dispatch(setModoTela('cadastro'));

				dispatch(getListaEstrutura(registroCarregado.respostas))

				// dispatch(getListaArea(registro.id_checklist));
				// dispatch(getListaPergunta(registro.id_checklist));
				// dispatch(getListaRespostaItem(registro.id_checklist_resposta));

				for (let i = 0; i < registro.checklist_respostas.length; i++) {
					const item = registro.checklist_respostas[i];
		
					const checklistResposta = getState().relatorio.listaChecklistResposta.filter(checklistResposta => checklistResposta.id == item)[0];
		
					if (checklistResposta && checklistResposta.id_status == 3) {
						await axios.put(`${consts.API_URL}/checklistResposta`, {
							...checklistResposta,
							id_status: 4, //Finalizar
							id_usuario_alteracao: getState().auth.usuario.id
						})
						.then(async result => {
						})
						.catch(erro => {
							setErroAPI(erro);
						});
					}
					
				}

				dispatch(getLista());
				dispatch(getListaChecklistResposta());

			}).catch(e => {
				console.log(e);
				setErroAPI(e);
			});
		} else {
			// axios.put(`${consts.API_URL}/relatorio`, {
			// 	...registro,
			// 	id_usuario_alteracao: getState().auth.usuario.id
			// }).then(resp => {
				// setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(getListaChecklistResposta());
				dispatch(setModoTela('lista'));
			// }).catch(e => {
			// 	setErroAPI(e);
			// });
		}
		
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/relatorio?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(getListaChecklistResposta());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaModeloRelatorio() {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/modeloRelatorio/listarSelect?id_usuario=${getState().auth.usuario.id}`).then(result => {
			dispatch({
				type: 'RELATORIO_MODELO_RELATORIO_SELECT_LISTADO',
				payload: result
			});
		}).catch(e => {
			console.log(e);
		});
	}
}

export function getListaChecklistResposta() {
    return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/checklistResposta?id_usuario=${getState().auth.usuario.id}`).then(result => {
			dispatch({
				type: 'RELATORIO_CHECKLIST_RESPOSTA_LISTADO',
				payload: result
			});
		}).catch(e => {
			console.log(e);
		});
	}
}

export function getListaCliente() {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/cliente/listarSelect?id_usuario=${getState().auth.usuario.id}`).then(result => {
			dispatch({
				type: 'RELATORIO_CLIENTE_SELECT_LISTADO',
				payload: result
			});
		}).catch(e => {
			console.log(e);
		});
	}
}

export function getListaChecklist() {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/checklist/listarSelect?id_usuario=${getState().auth.usuario.id}`).then(result => {
			dispatch({
				type: 'RELATORIO_CHECKLIST_SELECT_LISTADO',
				payload: result
			});
		}).catch(e => {
			console.log(e);
		});
	}
}

export function getListaUsuario() {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/usuario?id_usuario=${getState().auth.usuario.id}`).then(result => {
			dispatch({
				type: 'RELATORIO_USUARIO_SELECT_LISTADO',
				payload: result
			});
		}).catch(e => {
			console.log(e);
		});
	}
}

export function getListaGrupo() {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/grupoCliente/listarSelect?id_usuario=${getState().auth.usuario.id}`).then(result => {
			dispatch({
				type: 'RELATORIO_GRUPO_SELECT_LISTADO',
				payload: result
			});
		}).catch(e => {
			console.log(e);
		});
	}
}

export function gerarPdf(registro) {

	return (dispatch, getState) => {
		
		dispatch(setAguardando(true));

		axios.post(`${consts.API_URL}/relatorio/gerarPdf`, {
            ...registro,
			nome_checklist: (registro.respostas || []).length ? (registro.respostas || []).map(resposta => resposta.nome_checklist)[0] : null
        }).then(resp => {
			window.open(`${consts.URL}/${resp.data}`, '_blank');

			dispatch(setAguardando(false));
		}).catch(ex => {
			console.log(ex);
			dispatch(setAguardando(false));
		});

	}
}

export function salvarCheklistStatus(registro) {
	return async (dispatch, getState) => {

		await axios.put(`${consts.API_URL}/checklistResposta`, {
			...registro,
			id_usuario_alteracao: getState().auth.usuario.id
		})
		.then(async retorno => {
			dispatch(getLista());
			dispatch(getListaChecklistResposta());
			dispatch(setModoTela('lista'));
		})
		.catch(erro => {
			setErroAPI(erro);
		});	
    };
}


export function atualizarObjeto(registro) {

	return async (dispatch, getState) => {

		dispatch(setAguardando(true));

		setTimeout(async () => {
			await axios.get(`${consts.API_URL}/checklistResposta`).then(retorno => {

				if (retorno.data.filter(item => item.id == registro.checklist_resposta_objeto.id)[0]) {
					dispatch(initForm({
						...registro,
						checklist_resposta_objeto: {
							...(retorno.data.filter(item => item.id == registro.checklist_resposta_objeto.id)[0] || registro.checklist_resposta_objeto	)
						}
					}));
					dispatch(getListaEstrutura([(retorno.data.filter(item => item.id == registro.checklist_resposta_objeto.id)[0] || registro.checklist_resposta_objeto	)]));
				}

				dispatch(setAguardando(false));

			}).catch(erro => {
				setErroAPI(erro);
				dispatch(setAguardando(false));
			});
		}, 5000);

	}
}